jQuery.migrateMute = true;

angular.module('app.config').constant('variables', {
    default_theme: 'app_theme_a',
    default_mini_sidebar: false,
    default_boxed_layout: false,
    default_high_contrast: false,

    mobileMode: $(document).width() < 1100,

    header__main_height: 48,
    easing_swiftOut: [0.4, 0, 0.2, 1],
    bez_easing_swiftOut: $.bez([0.4, 0, 0.2, 1]),

    cacheLifetime: {
        fixed: {
            areas: 3600000, // 1h,
            users: 3600000, // 1h,
            notifications: 60000, // 1min
            reminders: 60000, // 1min
        },
        regexp: {
            'dictionaries/*': 3600000, // 1h,
        },
        default: 0, // none
    },

    defaults: {
        group_admin: 1,
        currency_id: 54,
        country_id: 46,
        unit_piece_id: 42,
        interest_status_id: 16,
        interest_win_id: 19,
        interest_loss_id: 20,
        task_status_id: 36,
        task_unfinished_id: 38,
        task_category_id: 21,
        project_status_started: 228,
        project_status_closed: 229,
        phase_status_started: 32,
        phase_status_closed: 35,
        crew_id_measurement: 17,
        crew_id_installation: 18,
        crew_id_service: 12,
        crew_id_transport: 11,
    },

    colors: {
        // css classes
        primary: '#2196f3',
        danger: '#e53935',
        warning: '#ffa000',
        success: '#7cb342',
        muted: '#bdbdbd',
        // types
        measurement: '#ffa000',
        installation: '#7cb342',
        transport: '#2196f3',
        service: '#e53935',
    },
});

angular.module('app.config').config(($logProvider, $sceDelegateProvider, $translateProvider, $sceProvider, $windowProvider, ChartJsProvider, app) => {
    $logProvider.debugEnabled(app.debug);

    // translations
    $translateProvider.preferredLanguage(app.lang);

    // sanitize for angular
    $sceProvider.enabled(false);
    $sceDelegateProvider.resourceUrlWhitelist(['self']);

    // chart colors
    ChartJsProvider.setOptions({
        colours: ['#1976d2', '#e53935', '#ffa000', '#8bc34a', '#0097a7'],
    });

    // timeago.js
    // https://github.com/hustcc/timeago.js/blob/master/locales/pl.js
    const $window = $windowProvider.$get();
    $window.timeago = timeago();
    $window.timeago.register('pl_PL', (number, index) => {
        const locale = [
            ['w tej chwili', 'za chwilę'],
            ['%s sekund temu', 'za %s sekund'],
            ['minutę temu', 'za minutę'],
            ['%s minut temu', 'za %s minut'],
            ['godzinę temu', 'za godzinę'],
            ['%s godzin temu', 'za %s godzin'],
            ['wczoraj', 'jutro'], // ['1 dzień temu', 'za 1 dzień'],
            ['%s dni temu', 'za %s dni'],
            ['tydzień temu', 'za tydzień'],
            ['%s tygodni temu', 'za %s tygodni'],
            ['miesiąc temu', 'za miesiąc'],
            ['%s miesięcy temu', 'za %s miesięcy'],
            ['rok temu', 'za rok'],
            ['%s lat temu', 'za %s lat'],
            ['%s sekundy temu', 'za %s sekundy'],
            ['%s minuty temu', 'za %s minuty'],
            ['%s godziny temu', 'za %s godziny'],
            ['%s dni temu', 'za %s dni'],
            ['%s tygodnie temu', 'za %s tygodnie'],
            ['%s miesiące temu', 'za %s miesiące'],
            ['%s lata temu', 'za %s lata'],
        ];
        return locale[index & 1 ? (number % 10 > 4 || number % 10 < 2 || 1 === ~~(number / 10) % 10 ? index : ++index / 2 + 13) : index];
    });
    $window.timeago.setLocale('pl_PL');
});
